module.exports = __webpack_public_path__ + "img/icon-login.d689d414.svg";